<template>
	<div class="widget-iframe-container">
		<div class="link-cover">
			<div class="dialog">
				<div class="link-label">
					<icon-link class="icon-link" />
					<div class="link-label-title">{{ this.title }}</div>
				</div>
				<br />
				<br />
				<div class="link-label-shortcut" @click="onLinkClick">{{ getMessage_('SWCC000714') }}<i class="el-icon-arrow-right"></i></div>
			</div>
		</div>

		<iframe
			ref="iframe"
			class="widget-iframe"
			:src="url"
			frameborder="0"
			framespacing="0"
			marginheight="0"
			marginwidth="0"
			scrolling="no"
			vspace="0"
		>
		</iframe>
	</div>
</template>
<script>
import client from '@/api/client';
import { rootComputed } from '@/store/common/helpers';
import IconLink from './IconLink.vue';
import { BASE_URL } from '@/constants';

const api = {
	selectMenu: ({ plantCd = 'HVS1' }) =>
		client.get(`${BASE_URL}/menu/v1/plants/${plantCd}/permScreens?currentPage=0&pageUnit=0`).then(r => r.data)
};

export default {
	components: {
		IconLink
	},
	props: {
		para: {
			type: Object,
			default: () => ({ settings: { target: '' } })
		}
	},
	mounted() {
		this.refresh();
	},
	computed: {
		...rootComputed,
		target() {
			const t = _.get(this.para, 'settings.target');
			// console.log('Link Target', t);
			return t;
		},
		url() {
			const params = { ...(_.get(this.targetOptionsMap, `${this.target}`) || {}), ...this.user };
			let linkUrl;
			if (params.scrUrl) {
				linkUrl = params.scrUrl;
			} else {
				linkUrl = `${BASE_URL}/CommonCode`;
				params.scrId = 'S00001086';
			}

			const qs = _(params)
				.pick(['topSkin', 'langCd', 'font', 'plantCd', 'scrId'])
				.omitBy(r => !r)
				.toPairs()
				.map(r => r.join('='))
				.value()
				.join('&');
			// console.log('Link URL', linkUrl, qs);
			return `${linkUrl}?${qs}`;
		},
		title() {
			const title = _.get(this.targetOptionsMap, `${this.target}.scrName`);
			return title;
		}
	},
	methods: {
		async refresh() {
			const res = await api.selectMenu(this.user);
			const list = _.uniqBy(res.body.resultList, r => r.msgKey);
			const targetOptions = list
				.map(r => {
					const msg = this.getMessage_(r.msgKey);
					return { ...r, value: r.scrUrl, label: msg };
				})
				.filter(r => r.msgKey && r.label && r.scrUrl)
				.sort(r => r.label);
			const targetOptionsMap = _(list)
				.filter(r => r.scrUrl && r.msgKey)
				.map(r => ({ ...r, label: this.getMessage_(r.msgKey) }))
				.keyBy('scrUrl')
				.value();
			this.targetOptions = targetOptions;
			this.targetOptionsMap = targetOptionsMap;
			// console.log('targetOptionMap', this.targetOptionsMap);
		},
		onClick(e) {
			e.stopPropagation();
			e.preventDefault();
		},
		onLinkClick(e) {
			const menu = this.targetOptionsMap[this.target];
			const message = {
				message: 'moveScreen',
				scrType: _.first(menu.scrType),
				scrId: menu.scrId,
				queryString: {}
			};
			// console.log('postMessage', message);
			window.parent.postMessage(message, '*');
		}
	},
	data() {
		return { targetOptions: [], targetOptionsMap: {} };
	}
};
</script>
<style></style>
